import React, { FC } from 'react';
import { Icon } from '../Icon/Icon';
import { NotificationIconType } from './Notification.types';
import { styled } from '../../styles';
import { CircularProgress } from '../Progress';

interface Props {
  type?: NotificationIconType;
}

export const NotificationImage: FC<Props> = ({ type }) => {
  const dataTest = `iconType_${type?.toLowerCase()}`;

  return (
    <StyledIcon>
      {type === 'INFO' && <Icon size={16} name="error" color="colorPrimary" dataTest={dataTest} />}
      {type === 'FAILURE' && <Icon size={16} name="error" color="colorAlert" dataTest={dataTest} />}
      {type === 'CANCELLED' && <Icon size={20} name="cancel" dataTest={dataTest} />}
      {type === 'IN_PROGRESS' && <CircularProgress size={20} dataTest={dataTest} />}
      {type === 'IS_QUEUED' && <Icon size={20} name="library_add" dataTest={dataTest} />}
      {type === 'PAUSED' && <Icon size={20} name="pause_circle" dataTest={dataTest} />}
      {type === 'SUCCESS' && <Icon size={20} name="check_circle" color="colorSuccess" dataTest={dataTest} />}
      {type === 'USER_AVATAR' && (
        <div
          style={{ backgroundColor: 'lightgray', width: 20, height: 20, borderRadius: '50%' }}
          data-test={dataTest}
        /> // TODO: implement user avatar when userUid is defined in the notification object
      )}
    </StyledIcon>
  );
};

const StyledIcon = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
`;
